module.exports = __webpack_public_path__ + "static/media/empty_data.a8a7ecab.svg";